export default __webpack_public_path__ + "static/media/knowledge-base-icon.668821fd.svg";